import React from 'react';

import { QuerySuspense } from 'common/components/QuerySuspense/';

import { usePurchaseOrderQuery } from '../../detail/hooks';
import { type BillingStatus } from '../../models';

type Props = {
  purchaseOrderId: string;
  children: (
    billingStatus: BillingStatus | undefined,
  ) => React.ReactElement | null;
};

export const PurchaseOrderMessageByBillingStatus = ({
  purchaseOrderId,
  children,
}: Props) => {
  const purchaseOrderQueryState = usePurchaseOrderQuery(purchaseOrderId);

  return (
    <QuerySuspense
      queryState={purchaseOrderQueryState}
      loading={null}
      fallback={() => null}
    >
      {(purchaseOrder) => children(purchaseOrder.billingStatus)}
    </QuerySuspense>
  );
};
